import AlerterView from 'chairisher/view/alerter';

import { submitForm } from 'chairisher/util/fetch';

/**
 * @param {jQuery} $holdFormWrapper Wrapper that contains a hold form.
 * @param {Function} onHoldComplete Function that runs after a hold is complete
 */
export default function bindHoldForm($holdFormWrapper, onHoldComplete) {
    const $holdForm = $holdFormWrapper.find('.js-product-action-hold');
    const $holdActionBox = $holdFormWrapper.find('.js-product-hold-action-box');
    const $holdActionRevealer = $holdFormWrapper.find('.js-product-hold-action-revealer');

    $holdActionRevealer.on('click', (e) => {
        e.preventDefault();
        $holdActionBox.removeClass('hidden');
        if ($holdActionRevealer.data('should-hide')) {
            $holdActionRevealer.addClass('hidden');
        }
        $holdActionRevealer.addClass('btn-primary').removeClass('btn-trade');
    });

    $holdFormWrapper.find('.js-product-hold-action-hider').on('click', (e) => {
        e.preventDefault();
        $holdActionBox.addClass('hidden');
        $holdActionRevealer.removeClass('btn-primary').addClass('btn-trade').removeClass('hidden');
    });

    $holdFormWrapper.find('.js-product-hold-action-submit').on('click', () => {
        $holdActionRevealer.closest('form').submit();
    });

    $holdForm.on('submit', async (e) => {
        e.preventDefault();

        const $submitButton = $holdForm.find('[type="submit"]');
        $submitButton.prop('disabled', true);

        try {
            await submitForm(e.currentTarget);
            onHoldComplete();
        } catch (error) {
            AlerterView.error();
            throw error;
        } finally {
            $submitButton.prop('disabled', false);
        }
    });
}
